import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-mp-aggarwal',
  templateUrl: './mp-aggarwal.component.html',
  styleUrls: ['./mp-aggarwal.component.scss']
})
export class MpAggarwalComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getMPagg();
  }
}
